import Jaco from "oc-modules/oc-jaco3d/arrangement/Jaco";
import { v3 } from "oc-modules/oc-threejs/short3";

// Eine Fläche auf der nicht dem Booth zugehörige Interiors gespeichert werden
export default class InteriorSpace extends Jaco {
  interiors = [];
  safetyDistanceBetweenInteriors = 0.3;
  safetyDistanceBetweenBoothAndInterior = 2;

  addInterior(interior) {
    if(!this.interiors.find( i => i.jaco3d.uuid == interior.jaco3d.uuid)) {
      console.log("adding interior", interior);
      this.interiors.push(interior);
    } else {
      console.log("not adding interior ", interior);
    }
  }

  removeInterior(interior) {
    this.interiors.remove((i) => i == interior);
  }

  update3d() {
    if (APP.arrangement.booth) {
      let startPosition = -APP.arrangement.booth.getSize().x / 2;
      this.interiors.forEach((i) => {
        const iWidth = i.getSize().x;
        i.position.copy(
          v3(
            startPosition + iWidth / 2,
            0,
            APP.arrangement.booth.getSize().z / 2 + this.safetyDistanceBetweenBoothAndInterior
          )
        );
        i.update3d();
        startPosition += iWidth + this.safetyDistanceBetweenInteriors;
      });
    }
  }
}
